import http from "@/api/http.js";
import axios from "axios";
import camelize from "camelize";
import { getSavedState } from "@/helpers/LocalStorage.js";

const version = require("../../../package.json").version;

function getCurrentToken() {
  try {
    return getSavedState("auth.currentUser")?.token || null;
  } catch (e) {
    return null;
  }
}

export function getPriceLevelsForStore(storeEndpoint) {
  const token = getCurrentToken();
  return axios
    .get(`${storeEndpoint}/infoauto/price_levels`, {
      headers: {
        Authorization: token,
        "X-App-Version": version
      },
      transformResponse: [
        function(data) {
          try {
            return camelize(JSON.parse(data));
          } catch (e) {
            return [];
          }
        }
      ]
    })
    .then(res => ({ data: res.data, error: false }))
    .catch(() => ({ data: [], error: true }));
}

export function getAdminUsers() {
  return http.get(`/administrators`).then(res => {
    return res;
  });
}

export function getAdminUser(id) {
  return http.get(`/administrators/single/${id}`).then(res => {
    return res;
  });
}

export function getPermissions() {
  return http.get(`/administrators/permissions`).then(res => {
    return res;
  });
}

export function getResetPasswordLink(id) {
  return http.get(`/administrators/password_link_admin/${id} `);
}

export function updateAdminUser(id, data) {
  return http.put(`/administrators/single/${id}`, { user: data });
}

export function createAdmin(data) {
  return http.post(`/administrators`, { user: data });
}

export function resetLoginAttempts(id) {
  return http.put(`/administrators/reset_attempts/${id}`);
}
